// extracted by mini-css-extract-plugin
export var attentiveText = "_53-0";
export var icon = "_53-1";
export var pillContainer = "_53-2";
export var pillContent = "_53-3";